 /*menuApp.service('API',['$http',function ($http) {
     
     this.cityRequest = function (url, body) {
        console.log(url,body);
        return API.post(url,body);
    }
     
     }]);*/